module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1031-3c6b2bfc741c872a6cabb626b36417f9.png";